<template>
  <div class="content-padding center-full">
    <div>
      <v-card :loading="loading" class="card-form">
        <v-card-title primary-title>
          <div class="container-logo">
            <img src="@/assets/img/logo-login.png" alt="Mi nómina Aliaddo" />
          </div>
        </v-card-title>
        <!--     <form v-on:submit.prevent="sendEmail()"> -->
        <v-card-text>
          <v-text-field
            label="Identificación"
            :rules="idRules"
            type="text"
            v-model.trim="identification"
            :hint="validId ? 'identificación válida!' : 'Ingrese su identificación!'"
            required
          ></v-text-field>
          <br />
          <div class="info-text">
            <p>
              A continuación recibirás un correo con las instrucciones para restablecer tu
              contraseña, ten presente que debes proporcionar un correo al área de recursos humanos
              de tu empresa, de lo contrario debes comunicarte con tu área de recursos humanos para
              que te asignen una contraseña.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <div>
            <v-btn color="primary" @click="sendEmail()" :disabled="!validId" :loading="loading"
              >{{ $t('rememberPassword') }}
            </v-btn>
          </div>
        </v-card-actions>
        <!-- </form> -->
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      identification: '',
      loading: false,
      email: '',
      idRules: [
        v => {
          return !!v || 'El número de identificación es requerido'
        }
      ]
    }
  },
  computed: {
    validId() {
      return this.identification.length > 0
    }
  },
  methods: {
    sendEmail() {
      this.loading = true
      this.$http
        .post(
          `${process.env.VUE_APP_API_HUB}/users/password-recovery-request/${this.$route.params.company}`,
          {
            userEmail: this.identification,
            productId: process.env.VUE_APP_PRODUCT_ID_HRM
          }
        )
        .then(
          () => {
            this.$swal({
              icon: 'success',
              title: this.$t('processSuccess'),
              text: this.$t('emailSent', [this.email]),
              confirmButtonColor: '#8bc34a'
            })
            // setTimeout(() => {
            //   this.$router.push("login");
            // }, 6000);
          },
          response => {
            this.$swal({
              icon: 'error',
              title: this.$t('errorOcurred'),
              text: response.bodyText ? response.bodyText : this.$t('identificationNotFound')
            })
            console.error('ERROR email > ', response)
          }
        )
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}

.card-form {
  padding: 0px 30px 40px 30px;
  max-width: 450px;
}

.center-full {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.container-logo {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 30px 0 0 0;
}
.container-logo img {
  height: 175px;
}

.info-text {
  width: 100%;
  text-align: center;
  color: #c1c1c1;
  font-size: 13px;
}
</style>
